import * as Constants from './functions/Constants';

const AWS_CONFIG = {
    "aws_cognito_region": Constants.AWS_REGION,
    "aws_user_pools_id": Constants.AWS_USER_POOLS_ID,
    "aws_user_pools_web_client_id": Constants.AWS_USER_POOLS_WEB_CLIENT_ID
};

export default AWS_CONFIG;
